export enum AinErrorType {
  LATE_DELIVERY = 'Late Delivery',
  RFID_LABEL_MISSING = 'RFID Label Missing',
  WRONG_LABEL = 'Wrong Label',
}
